import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const COMPLIANCE_DOCUMENTS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('COMPLIANCE_DOCUMENTS');
export const COMPLIANCE_DOCUMENTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	COMPLIANCE_DOCUMENTS_CRUD_ACTION_CONSTANTS
);
